import React from 'react';
import { Spinner } from 'react-bootstrap';

import { ButtonLoader } from './buttons';

export function MapLoadingIndicator() {
  return (
    <ButtonLoader>
      <Spinner size="sm" animation="border" />
    </ButtonLoader>
  );
}
